module.exports = "/_next/static/images/48b67f90b2d136b6198e8c15da796d4e-green-check.svg";